/**
 * commitPendingOTOCore — nucleo PURO de commitPendingOTOUpdates (extraido de
 * InteractiveOrderIntegration.jsx para teste unitario).
 *
 * Decide se ha mudanca real nas pernas OTO pendentes e, se houver, aplica os precos
 * FINITOS via updateOTOPrice, descartando NaN/Infinity SEM corromper o store
 * (Diretiva 1: falha nunca silenciosa — hoje o aviso e apenas console.warn; o callback
 * onSkip permite ao chamador futuro materializar o feedback).
 *
 * O ciclo de vida do ref `_pending` (setTimeout/delete) permanece no componente —
 * aqui so vive a logica de decisao+despacho, sem efeitos colaterais de React.
 *
 * @param {Object}   args
 * @param {string}   args.orderId
 * @param {Map}      args.pendingUpdates       Map<otoId, {price, deltaTicks} | number>
 * @param {Array}    args.orders               ordens correntes do store
 * @param {Function} args.validateOrderReplacement  injetado (centralizado)
 * @param {Function} args.updateOTOPrice       injetado (escreve no store)
 * @param {Function} [args.onSkip]             notificado por preco nao-finito descartado
 * @returns {{applied: string[], skipped: string[], hadChanges: boolean}}
 */
export function commitPendingOTOCore({
  orderId,
  pendingUpdates,
  orders,
  validateOrderReplacement,
  updateOTOPrice,
  onSkip,
}) {
  const applied = [];
  const skipped = [];

  if (!pendingUpdates) {
    return { applied, skipped, hadChanges: false };
  }

  let hasAnyChanges = false;

  pendingUpdates.forEach((pendingData, otoOrderId) => {
    const newPrice =
      typeof pendingData === "object" ? pendingData.price : pendingData;
    const mainOrder = orders.find((o) => o.id === orderId);
    if (mainOrder && mainOrder.oto) {
      const originalOtoOrder = mainOrder.oto.find(
        (oto) => oto.id === otoOrderId,
      );
      if (originalOtoOrder) {
        const validation = validateOrderReplacement({
          dragStart: null,
          dragEnd: null,
          originalOrder: originalOtoOrder,
          newValues: { price: newPrice },
          operationType: "oto-order",
        });
        if (validation.hasChanges) {
          hasAnyChanges = true;
        }
      }
    }
  });

  if (hasAnyChanges) {
    pendingUpdates.forEach((pendingData, otoOrderId) => {
      const newPrice =
        typeof pendingData === "object" ? pendingData.price : pendingData;
      const storedDeltaTicks =
        typeof pendingData === "object" ? pendingData.deltaTicks : undefined;

      // Skip NaN/Infinity prices - don't corrupt the store
      if (!isFinite(newPrice)) {
        skipped.push(otoOrderId);
        if (onSkip) onSkip(otoOrderId, newPrice);
        return;
      }

      updateOTOPrice(orderId, otoOrderId, newPrice, {
        programmatic: true,
        skipRouterCall: true,
        deltaTicks: storedDeltaTicks,
      });
      applied.push(otoOrderId);
    });
  }

  return { applied, skipped, hadChanges: hasAnyChanges };
}
